// app.config.ts
const baseURL = 'https://cdn.forward-audio.com/';
const apiVersion = 'v1';

export default {
  baseURL,
  apiVersion,

  endpoints: {
    access: {
      generateToken: `${baseURL}${apiVersion}/ny3eot687jmdxo323lkr2m8aw0z7hpoo`,
      regenerateToken: `${baseURL}${apiVersion}/o766w0qodulqrjff4rg8p3nd3rujdbch`,
      update: `${baseURL}${apiVersion}/rqs526ve0myzzfrpgz78h0upcuzh8jus`,
    },

    cart: {
      get: `${baseURL}${apiVersion}/hdznwc98ialq0hmugid0s1gvjy7oc6h5`,
      clear: `${baseURL}${apiVersion}/3brfmdsh7d85zed0dppduyv5vokfjnp0`,
      checkout: `${baseURL}${apiVersion}/ue0rot0jyyig46767shwj2jva4xogi4b`,
      addProduct: `${baseURL}${apiVersion}/vofr1p74gla67f6ynx9r11whd0k269nc`,
      removeProduct: `${baseURL}${apiVersion}/t96kkdcl7dqwlbsstutyj85ri9ujdh17`,
      addCoupon: `${baseURL}${apiVersion}/hksw7sqbokywwsmvipq25d3ohvgv328f`,
      removeCoupon: `${baseURL}${apiVersion}/j2zy2l8m7ddzsmvqg4kt8u8l9kfeb2fs`,
      buyNow: `${baseURL}${apiVersion}/t0e465ivb9i52hwo0g37fpur45n12eld`,
    },

    product: {
      getAllProducts: `${baseURL}${apiVersion}/j546i90d15ge3adfmdp5y7760b3qplhc`,
      getData: `${baseURL}${apiVersion}/48w9d5vyizsq7wdr59kqgsabswmfnk86`,
      getPromotions: `${baseURL}${apiVersion}/3xmiez5uvmrbrl9hyzm956qp1oxjr0si`,
      getLiveStats: `${baseURL}${apiVersion}/xg764le2cpark7jtg7vypmnulszgw6yf`,
      redeemProduct: `${baseURL}${apiVersion}/pc5rqk6cpdwuan3l548saasedxkr57kb`,
      download: `${baseURL}${apiVersion}/okogvmb0sxj9gr9rfj3a47ulxelxy3g5`,
    },

    user: {
      ipAddress: `${baseURL}${apiVersion}/nmhroe7ebxo4h9znh5l9864m1w42q2cw`,
      isValidEmail: `${baseURL}${apiVersion}/hrpbcs01aoldpivuwx5f1o7t9wz811i7`,
      resendActivation: `${baseURL}${apiVersion}/a9y2ovd7pnh2vvnhtzrixsz4jyla2ybt`,
      register: `${baseURL}${apiVersion}/0s772gm1atdfumt7g8t8alknmaz5emzp`,
      login: `${baseURL}${apiVersion}/mnpxjnfmb3mtb1nr1ht0uv59kynoi1vc`,
      logout: `${baseURL}${apiVersion}/eumauzvpwsk4zpwhu22ip5sbatxtrauc`,
      getProducts: `${baseURL}${apiVersion}/18c8k3869z7kz1mn3clk91dy2e6to7ib`,
      getLicenseTransfer: `${baseURL}${apiVersion}/qt1tzvzlyth53vbu41udhtfea369pmxq`,
      updateProfile: `${baseURL}${apiVersion}/wzkve6a1ogzsdyzobqr12ga3e77y7euv`,
      changePassword: `${baseURL}${apiVersion}/teux3oz8jce6jibbxbftpftp5h0xh013`,
      updateNewsletterSettings: `${baseURL}${apiVersion}/mytkdtdleeuayo1xkaylwt6174d5waq5`,
      passwordForget: `${baseURL}${apiVersion}/c32cbbm98cqev3olyffrej3xirbx0v5g`,
      verifyMail: `${baseURL}${apiVersion}/k2awli3c7x8jtob70gvl3p3ppfgh3do3`,
      rateProduct: `${baseURL}${apiVersion}/dsvdvkhkvbl3zmxvlttntjnfod2kaumh`,
    },
  }
}
